import gen from '../gen'
import router from '../../../router'
var ls = require('local-storage');
import axios from 'axios'

const state = {
  spotType_uploadImage: [],
  selectedSpotType_uploadImage: [],
  //
  anyoneCanVisitThisSpot_uploadImage : true
}

const getters = {

}

const mutations = {
  //
  goTo_uploadImage_5(state2, payload) {
    // console.log("[uploadImage_4]", payload)
    //
    //validate array if not empty
    //if(payload.spotType.length != 0){
      //proceed
      //
      router.push({
        path: '/uploadImage_5',
        query: {
          url: payload.url,
          resourceType: payload.resourceType,
          publicId: payload.publicId,
          //
          createdAt: payload.createdAt,
          //
          caption: payload.caption,
          emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
          //
          shareSpotLocation: JSON.stringify(payload.shareSpotLocation),
          hasGeohash: payload.hasGeohash,
          //
          spotType: JSON.stringify(payload.spotType),
          anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot
        }
      })
    //} else { // error
      //gen.mutations.snackbar_alert(state, {
        //msg: 'Please select at least one tag in spot type related to the image'
      //})
    //}
    //
  },
  //
  // get google map api
  getSpotTypeSuggestions_fromLocalStorage(state2) {
    let gotSpotTypeSuggestionsFromLocalStorgae = JSON.parse(ls.get('spotTypeSuggestions'))
    if(gotSpotTypeSuggestionsFromLocalStorgae != null) {
      state.spotType_uploadImage = gotSpotTypeSuggestionsFromLocalStorgae
    }
  }
}

const actions = {

}

export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/uploadImage_4.js